import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, ComboBox, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ExportModal = ({ show, onClose, onExport, cardName }) => {
  const { t } = useTranslation()
  const [format, setFormat] = useState('csv')
  const [loading, setLoading] = useState(false)

  const handleOnExport = async () => {
    setLoading(true)
    await onExport(format)
    setLoading(false)
    onClose()
  }

  return (
    <Modal show={show} onClose={onClose} title={t('Exportar datos')} size="l">
      <Styles.Container>
        <Text type="bodyMRegular">
          {t('Elige un formato para exportar los datos de')}: {cardName}
        </Text>
        <ComboBox
          label={t('Formato')}
          handleChange={e => setFormat(e.target.value)}
          value={format}
          menuItems={[
            { label: '.csv', value: 'csv' },
            { label: '.xlsx', value: 'xlsx' },
          ]}
        />
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            onClick={handleOnExport}
            defaultLabel={t('Exportar')}
            loadingLabel={t('Exportar')}
            loading={loading}
            disabled={loading}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default ExportModal
